import React from 'react';

import { Spacer } from '@zillow/constellation';

import type { Section } from '../../../../models/index';
import { SEPARATE_HEATING_CHARGE } from '../../../../constants';
import HeaderToggle from '../Utilities/HeaderToggle';
import MultiFamilyLandlordUtility from '../Utilities/MultiFamilyLandlordUtility';
import { CenteredHR } from '../../../Widgets/CenteredHR';
import SwitchWithTitle from '../../../Widgets/SwitchWithTitle';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

export default function SeparateHeatingCharge_v2({ section, setSectionValues }: Props): JSX.Element {
  const separateHeatingCharge_isEnabled = section.getFieldValue(SEPARATE_HEATING_CHARGE.FIELD_NAME.IS_ENABLED);

  function toggleUtility(): void {
    setSectionValues({
      [SEPARATE_HEATING_CHARGE.FIELD_NAME.IS_ENABLED]: !section.getFieldValue(
        SEPARATE_HEATING_CHARGE.FIELD_NAME.IS_ENABLED,
      ),
    });
  }

  function togglePaysInAddition(): void {
    setSectionValues({
      [SEPARATE_HEATING_CHARGE.FIELD_NAME.TENANT_PAYS_IN_ADDITION_TO_RENT]: !section.getFieldValue(
        SEPARATE_HEATING_CHARGE.FIELD_NAME.TENANT_PAYS_IN_ADDITION_TO_RENT,
      ),
      [SEPARATE_HEATING_CHARGE.FIELD_NAME.FORMULA]: '',
      [SEPARATE_HEATING_CHARGE.FIELD_NAME.MONTHLY_COST_PERCENTAGE]: '',
    });
  }

  return (
    <>
      <HeaderToggle
        header="Separate heating charge"
        subheader="Applies to this property"
        switchOn={separateHeatingCharge_isEnabled}
        onSwitchToggle={toggleUtility}
      />
      {separateHeatingCharge_isEnabled && (
        <Spacer marginBottom="sm" data-test="separateHeatingCharge_isEnabled">
          <CenteredHR />
          <SwitchWithTitle
            text="Tenant pays in addition to rent"
            onClick={togglePaysInAddition}
            toggled={section.getFieldValue(SEPARATE_HEATING_CHARGE.FIELD_NAME.TENANT_PAYS_IN_ADDITION_TO_RENT)}
          />
        </Spacer>
      )}
      {section.getFieldValue(SEPARATE_HEATING_CHARGE.FIELD_NAME.TENANT_PAYS_IN_ADDITION_TO_RENT) && (
        <MultiFamilyLandlordUtility
          section={section}
          utilityName="heat/heating"
          percentageFieldName={SEPARATE_HEATING_CHARGE.FIELD_NAME.MONTHLY_COST_PERCENTAGE}
          formulaFieldName={SEPARATE_HEATING_CHARGE.FIELD_NAME.FORMULA}
          setSectionValues={setSectionValues}
        />
      )}
    </>
  );
}
